export default __webpack_public_path__ + "static/play-agent1-bop-hindi-bf23fe2f322c7f078b24cc3741ba270c.png";